module.exports = __webpack_public_path__ + "img/character_i.0180be8c.svg";